import React, { useMemo } from 'react'
import { Bar } from 'react-chartjs-2'

const AlertByTypeBarchart = ({ isDarkTheme, SiteName, handleModalShow, siteId, getcsvFileName, alertsData }) => {
  // Flatten alertsData if it's an object with keys (as in your API response)
  const flatAlertsData = Array.isArray(alertsData)
    ? alertsData
    : alertsData && typeof alertsData === 'object'
      ? Object.values(alertsData).flat()
      : [];

  // Memoize labels and values from WidgetID 7
  const { alertTypeLabels, alertTypeCounts } = useMemo(() => {
    let alertTypeLabels = [];
    let alertTypeCounts = [];
    const widget7 = flatAlertsData.find(item => item.WidgetID === 7 && item.WidgetData);
    if (widget7 && widget7.WidgetData.AlertType && widget7.WidgetData.AlertCount) {
      alertTypeLabels = widget7.WidgetData.AlertType;
      alertTypeCounts = widget7.WidgetData.AlertCount;
    }
    return { alertTypeLabels, alertTypeCounts };
  }, [flatAlertsData]);

  const data = {    
    labels: alertTypeLabels,  
    datasets: [{
      data: alertTypeCounts,
      fill: false,
      backgroundColor: [
        'rgb(46, 185, 249)', 
      ],
      borderWidth: 0,
      borderRadius: 5,
      barThickness: 25,
      maxBarThickness: 30,
    }]
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            let dataset = tooltipItem.dataset;
            let value = dataset.data[tooltipItem.dataIndex];
            let label = dataset.labels ? dataset.labels[tooltipItem.dataIndex] : "";
            return `${label}: ${value}`;
          },
        },
      },
      legend: {
        display: false,
        position: 'bottom',
        labels: {
          boxWidth: 14,
          fontColor: '#474747',
          fontFamily: '7px Montserrat',
        },
      },
      tooltip: {
        display: true,
      },
      animations: {
        tension: {
          duration: 1000,
          easing: 'active',
          from: 1,
          to: 0,
        }
      },
    },
    onClick: (event, elements, chart) => {
      if (elements && elements.length > 0 && typeof handleModalShow === "function") {
        const element = elements[0];
        const index = element.index;
        const label = chart.data.labels[index];
        handleModalShow({AlertType: label}, "Alert", 30, {SiteID:[siteId]}, getcsvFileName('Alert', label), "Alert Counts By Type");
      }
    },
    scales: {
      x: {
        stacked: false,
        border: {
          display: true,
          color: isDarkTheme ? '#bababa' : "#bababa",
        },
        grid: {
          display: false,
          color: "red",
          borderColor: "red"
        },
        title: {
          display: true,
          text: "Alert Type",
          color: isDarkTheme ? "#000000" : "#6e6e6e",
          font: {
            size: 13,
            weight: 'bold',
          },
        },
        ticks: {
          color: isDarkTheme ? "#bababa" : "#bababa",
        },
      },
      y: {
        stacked: false,
        border: {
          display: true,
          color: isDarkTheme ? '#bababa' : "#e6e6e6",
        },
        beginAtZero: true,
        title: {
          display: true,
          text: "No of alerts",
          color: isDarkTheme ? "#000000" : "#6e6e6e",
          font: {
            size: 13,
            weight: 'bold',
          },
        },
        grid: {
          display: false,
          color: "#faf7f7"
        },
        ticks: {
          color: isDarkTheme ? "#bababa" : "#bababa",
        },
      },
    },
  };

  return (
    <div style={{padding:"10px", height:"90%", display:"flex", justifyContent:"center",alignItems:"center"}}>
      {alertTypeLabels.length > 0 ? (
        <Bar options={options} data={data}/>
      ) : (
        <div style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold", color: "gray" }}>
            No alerts found
        </div>
      )}
    </div>
  )
}

export default AlertByTypeBarchart